import Account from "../Components/Account"

function Login(){
    return(
        <Account/>
    )
}

export default Login